import styled, { keyframes } from 'styled-components'

const enterUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const Page = styled.div`
  animation: ${enterUp} .32s ease both;
  padding: 40px clamp(20px, 4vw, 56px) 56px;
`

export const PageHeader = styled.div`
  align-items: flex-end;
  display: flex;
  gap: 24px;
  justify-content: space-between;
  margin-bottom: 28px;

  @media (max-width: 760px) {
    align-items: stretch;
    flex-direction: column;
  }
`

export const PageIntro = styled.div`
  max-width: 680px;
`

export const PageEyebrow = styled.div`
  color: ${({ theme }) => theme.palette.colors.subdued || theme.palette.colors.muted};
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0;
  margin-bottom: 8px;
  text-transform: uppercase;
`

export const PageTitle = styled.h1`
  color: ${({ theme }) => theme.palette.colors.text};
  font-size: clamp(30px, 3vw, 44px);
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1.05;
  margin: 0 0 10px;
`

export const PageSubtitle = styled.p`
  color: ${({ theme }) => theme.palette.colors.muted};
  font-size: 14px;
  line-height: 1.55;
  margin: 0;
  max-width: 560px;
`

export const HeaderActions = styled.div`
  align-items: center;
  display: flex;
  gap: 10px;
  justify-content: flex-end;

  @media (max-width: 760px) {
    justify-content: flex-start;
  }
`

export const Panel = styled.section`
  animation: ${enterUp} .42s ease .08s both;
  background: ${({ theme }) => theme.palette.colors.surfaceElevatedSoft || theme.palette.colors.light};
  border: 1px solid ${({ theme }) => theme.palette.colors.borderSoft || theme.palette.colors.borderStrong};
  border-radius: 8px;
  box-shadow: 0 18px 48px ${({ theme }) => theme.palette.colors.shadowStrong || 'rgba(0, 0, 0, .18)'};
  overflow: auto;
`

export const PanelHeader = styled.div`
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.palette.colors.borderSoft || theme.palette.colors.borderStrong};
  display: flex;
  gap: 18px;
  justify-content: space-between;
  padding: 18px 20px;
`

export const PanelTitle = styled.h2`
  color: ${({ theme }) => theme.palette.colors.text};
  font-size: 17px;
  font-weight: 800;
  letter-spacing: 0;
  margin: 0;
`

export const PanelMeta = styled.div`
  color: ${({ theme }) => theme.palette.colors.subdued || theme.palette.colors.muted};
  font-size: 13px;
  margin-top: 4px;
`
